import { RelationIdAttribute } from "./RelationIdAttribute"

export interface RelationIdLoadResult {
    relationIdAttribute: RelationIdAttribute
    results: any[]
}
